import React, { useState, useEffect } from 'react';
import { Input } from 'antd';

function DebouncedInput({
  value, onChange, debounceTimeout, ...props
}) {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (inputValue !== value) {
        onChange(inputValue);
      }
    }, debounceTimeout);

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue, onChange, debounceTimeout, value]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  return <Input {...props} value={inputValue} onChange={handleInputChange} />;
}

DebouncedInput.defaultProps = {
  debounceTimeout: 1000,
};

export default DebouncedInput;
